import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
  TableBodySkeleton,
} from '../../../common';
import SupplyOrderStatusChip from './SupplyOrderStatusChip';

const SupplyOrdersDataTable = ({
  data,
  isLoading,
  onView,
  onEdit,
  LoadingComponent = TableBodySkeleton,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((order, index) => (
              <Box
                key={order.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                  {order.number}
                </Typography>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Origen
                  </Typography>
                  <Typography variant="body2">
                    {order.source_type_label}: {order.source_label}
                  </Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Destino
                  </Typography>
                  <Typography variant="body2">{order.destination_label}</Typography>
                </Box>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="caption" color="text.secondary">
                    Fecha
                  </Typography>
                  <Typography variant="body2">{order.order_date_label}</Typography>
                </Box>
                {order.source_type === 'provider' && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                      Compromiso proveedor
                    </Typography>
                    <Typography variant="body2">
                      {order.provider_delivery_commitment_at_label}
                    </Typography>
                  </Box>
                )}
                <Box sx={{ mb: 2 }}>
                  <SupplyOrderStatusChip status={order.status} />
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onView(order)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron órdenes de abastecimiento" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="supply orders table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="9%" wxs="9%">
              Número
            </HeadTableCell>
            <HeadTableCell wmd="9%" wxs="9%">
              Tipo origen
            </HeadTableCell>
            <HeadTableCell wmd="14%" wxs="14%">
              Origen
            </HeadTableCell>
            <HeadTableCell wmd="14%" wxs="14%">
              Destino
            </HeadTableCell>
            <HeadTableCell wmd="11%" wxs="11%">
              Fecha
            </HeadTableCell>
            <HeadTableCell wmd="11%" wxs="11%">
              Compromiso
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Estado
            </HeadTableCell>
            <HeadTableCell wmd="9%" wxs="9%">
              Pedido técnico
            </HeadTableCell>
            <HeadTableCell wmd="13%" wxs="13%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((order, index) => (
              <TableRow key={order.uuid || index}>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.number}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.source_type_label}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.source_label}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.destination_label}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.order_date_label}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.source_type === 'provider'
                    ? order.provider_delivery_commitment_at_label
                    : '-'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  <SupplyOrderStatusChip status={order.status} />
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {order.external_order_label}
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                    <ActionIconButton variant="edit" onClick={() => onView(order)} />
                    {order.status === 'draft' && onEdit && (
                      <ActionIconButton variant="add" onClick={() => onEdit(order)} />
                    )}
                  </Box>
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={9} message="No se encontraron órdenes de abastecimiento" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default SupplyOrdersDataTable;
